







import {Component, Prop, Vue} from 'vue-property-decorator';
import AlbrisIcon from '@/assets/icons/albris.svg';
import AnafiIcon from '@/assets/icons/anafi.svg';
import BluegrassIcon from '@/assets/icons/bluegrass.svg';
import ClassicIcon from '@/assets/icons/classic.svg';
import DuetM from '@/assets/icons/DuetM.svg';
import eBeeAg1 from '@/assets/icons/ag.svg';
import eBeeAg2 from '@/assets/icons/eBee-Ag.svg';
import eBeeGeo from '@/assets/icons/eBee-Geo.svg';
import eBeeTac from '@/assets/icons/eBee-TAC.svg';
import EBeeXIcon from '@/assets/icons/eBeeX.svg';
import EMotion3Icon from '@/assets/icons/eMotion3.svg';
import EMotionIcon from '@/assets/icons/eMotion.svg';
import GeobaseIcon from '@/assets/icons/geobase.svg';
import ParrotIcon from '@/assets/icons/parrot.svg';
import Pix4dDesktopIcon from '@/assets/icons/pix4d-desktop.svg';
import Pix4dMobileIcon from '@/assets/icons/pix4d-mobile.svg';
import PlusIcon from '@/assets/icons/plus.svg';
import RtkIcon from '@/assets/icons/rtk.svg';
import SequoiaIcon from '@/assets/icons/sequoia.svg';
import SodaIcon from '@/assets/icons/soda.svg';
import SqIcon from '@/assets/icons/sq.svg';
import SwingletIcon from '@/assets/icons/swinglet.svg';
import ThermomapIcon from '@/assets/icons/thermomap.svg';

@Component({
  components: {
    AlbrisIcon,
    AnafiIcon,
    BluegrassIcon,
    ClassicIcon,
    DuetM,
    eBeeAg1,
    eBeeAg2,
    eBeeGeo,
    eBeeTac,
    EBeeXIcon,
    EMotion3Icon,
    EMotionIcon,
    GeobaseIcon,
    ParrotIcon,
    Pix4dDesktopIcon,
    Pix4dMobileIcon,
    PlusIcon,
    RtkIcon,
    SequoiaIcon,
    SodaIcon,
    SqIcon,
    SwingletIcon,
    ThermomapIcon,
  },
})
export default class ProductIconName extends Vue {
  @Prop() public icon: string;
  @Prop() public name: string;
  @Prop({ default: '' }) public parent: string;

  public parentClass = this.parent === 'mobile' ? 'product-icon-name--mobile' : '';
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/ProductIconName/ProductIconName.vue